<template>
  <div class="multiselect-page">
    <side-bar :is-multi-select="true" />

    <div class="multiselect-main-container">

      <multiselect-table
        :layer="multiSelectData.layers[activeTab].layer"
        :lists-are-loaded="listsAreLoaded"
        :multi-select-data="multiSelectData"
        @closureDelete="closureDelete = $event"
        @setObjectCount="objectCount = $event"
      >
        <div slot="header" class="header">
          <div>
            <h2 class="management-section-title">MULTISELECT</h2>

            <h4>Objects: {{ objectCount }}</h4>
          </div>

          <div class="buttons-container">

            <!-- NOT FOR NOW -->
            <!-- <management-button
              type="execute"
              :label="$t('Merge')"
              @buttonClick="mergeData"
              :disabled="false"
              :align="'left'"
            >
              <v-icon>close_fullscreen</v-icon>
            </management-button> -->

            <management-button
              type="execute"
              :label="$t('Export')"
              @buttonClick="exportData"
              :disabled="numberSelectedObjects === 0"
              :align="'left'"
            >
              <v-icon>download</v-icon>
            </management-button>
            <management-button
              type="execute"
              :label="$t('Save')"
              @buttonClick="saveData"
              :disabled="saveButtonIsDisabled"
              :align="'left'"
            >
              <v-icon>save</v-icon>
            </management-button>
          </div>
        </div>
      </multiselect-table>

      <tabs
        v-if="multiSelectData.layers.length > 0"
        :tabs="tabs"
        :active-tab="activeTab"
        :translate-labels="true"
        :tabs-styling="tabsStyling"
        @startTabChange="activeTab = $event"
      />
    </div>

    <!--
      :can-modify-objects=true
      :can-generate-request=false
    -->
    <multiselect-toolbar
      :layer="multiSelectData.layers[activeTab].layer"
      :closure-delete="closureDelete"
      @closeDialogDeleteClosure="closureDelete.dialogOpen = false"
    />
  </div>
</template>

<script>
import SideBar from "@/components/Home/SideBar/SideBar";
import { bus } from "@/main.js";
import { mapActions } from 'vuex';
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import MultiSelectionToolbar from "@/components/Home/Forms/MultiSelectionForm/MultiSelectionToolbar";
import MultiSelectionTable from "@/components/Home/Forms/MultiSelectionForm/MultiSelectionTable";
import MultiselectToolbar from "@/components/Multiselect/MultiselectToolbar";
import MultiselectTable from "@/components/Multiselect/MultiselectTable";
import ManagementButton from '@/components/Management/ManagementButton.vue';
import Tabs from '@/components/_Organisms/Tabs.vue';

export default {
  name: "MultiSelect",

  components: {
    SideBar,
    MultiSelectionToolbar,
    MultiSelectionTable,
    ManagementButton,
    MultiselectToolbar,
    MultiselectTable,
    Tabs,
  },

  mixins:[checkPermissionsMixin],

  props: {},

  data() {
    return {
      initials: undefined,

      tabs: [],
      activeTab: 0,

      multiSelectData: {},

      closureDelete: {
        dialogOpen: false,
        associatedCables: null
      },

      tabsStyling: {
        margin: '10px auto',
        'background-color': 'white',
        'border-radius': '8px',
        'box-shadow': '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        width: '97%',
        position: 'absolute',
        left: '25px',
        bottom: '3px',
      },

      listsAreLoaded: false,
      saveButtonIsDisabled: true,

      dataToExport: null,
      numberSelectedObjects: 0,

      objectCount: 0,
    }
  },

  computed: {
    permissionsWereLoaded() {
      return this.isSuperAdmin ? true : this.$store.getters.getUserPermissions.length > 0;
    },

    fileName() {
      const workspace = this.$store.getters.workspace.label;
      let layer = this.tabs[this.activeTab].label.replace("fc_", "");
      return workspace + "_" + layer;
    }
  },

  watch: {
    permissionsWereLoaded() {
      if (this.permissionsWereLoaded && this.userHasFibercloudPermission("list_list")) {
        this.loadLists();
      }
    },

    dataToExport(newDataSet) {
      if (newDataSet) {
        this.exportCSVFile();
      }
    }
  },

  created() {
    if (this.$store.getters.getAllObjectTypesProperties.length === 0) {
      this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
    }
  },

  beforeMount() {
    this.multiSelectData = JSON.parse(window.localStorage.getItem('multiObjectSelection'));
    this.multiSelectData.layers.map(object => {
      this.tabs.push({ id: object.id, label: object.layer })
    });
  },

  mounted(){
    bus.$on("multiple-selection-update-save-button-state", saveButtonIsDisabled => {
      this.saveButtonIsDisabled = saveButtonIsDisabled;
    });

    bus.$on("multiple-selection-set-data-to-export", dataToExport => {
      this.dataToExport = dataToExport;
    });

    /**
     * Opens a channel to receive updates on the number of objects selected
     */
     bus.$on("multiple-selection-update-number-selected-objects", numberSelectedObjects => {
      this.numberSelectedObjects = numberSelectedObjects;
    });
  },

  methods:{
    ...mapActions([
      "FETCH_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE",
      "FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS",
      "GET_ALL_LISTS",
    ]),

    async loadLists() {
      try {
        await this.GET_ALL_LISTS();
        this.listsAreLoaded = true;
      } catch (e) {
        console.error();
      }
    },

    exportData() {
      bus.$emit('multiple-selection-get-data-to-export');
    },

    exportCSVFile() {
      const csv = this.convertToCSV(this.dataToExport);

      const exportedFileName = this.getExportFileName();

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      this.dataToExport = null;
    },

    convertToCSV(objectArray) {
      let csvContent = "";
      for (const object of objectArray) {
        csvContent += this.getCsvLine(object);
      }
      return csvContent;
    },

    getCsvLine(object) {
      let line = [];
      for (const value of Object.values(object)) {
        let cleanValue = this.getCleanValue(value);
        line.push('"' + cleanValue + '"');
      }
      line = line.join(";");
      return line + "\r\n";
    },

    getCleanValue(value) {
      let cleanValue = value;
      if (typeof value === "string") {
        if (value.includes('"')) {
          cleanValue = value.replace('"', "'");
        }
        if (value.includes(";")) {
          cleanValue = value.replace(";", ",");
        }
      }
      return cleanValue;
    },

    getExportFileName() {
      let fileName = this.fileName ? this.fileName : "export";
      let timestamp = this.getTimestamp();
      return fileName + "_" + timestamp + ".csv";
    },

    getTimestamp() {
      const today = new Date();

      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      const time =
        today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds();

      return date + "T" + time;
    },

    saveData() {
      bus.$emit("multiple-selection-save");
    },
  },

  destroyed() {
    bus.$off("multiple-selection-update-save-button-state");
    bus.$off("multiple-selection-set-data-to-export");
    bus.$off("multiple-selection-update-number-selected-objects");
  },
};
</script>

<style scoped>
.no-select {
  user-select: none;
}

.with-select {
  user-select: text;
}

th {
  position: sticky;
  top: 0;
  background-color: #f3f5f7;
  z-index: 1;
}

input:invalid,
textarea:invalid {
  border-bottom: 1px solid var(--red);
}

.multiselect-page {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.sidebar {
  position: relative !important;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25) !important;
  border-right: none !important;
}

.multiselect-main-container {
  width: calc(100% - 98px);
  background-color: #F3F5F7;
  height: 100%;
  position: relative;
}

.multi-selection-table-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 96px) !important;
  width: 97%;
  margin: 15px auto 0 auto;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.multi-selection-table-container >>> .load-data-button {
  margin-top: 20% !important;
}

.buttons-container {
  display: flex;
  align-items: center;
}

.buttons-container >>> .management-button {
  margin-bottom: 0px !important;
  border-radius: 8px;
}

.management-section-title {
  padding: 20px 25px 0px 25px;
  font-size: 17px;
}

</style>


// WEBPACK FOOTER //
// src/views/MultiSelect.vue